/* Layout */
import Layout from '../../views/layout/Layout.vue'

const CouponList = () => import(/* webpackChunkName: "coupon-list" */ '@/views/coupon/list')
const CouponDetail = () => import(/* webpackChunkName: "coupon-detail" */ '@/views/coupon/detail')

export default [
  {
    path: '/coupon',
    component: Layout,
    redirect: '/coupon/list',
    name: 'Coupon',
    alwaysShow: true,
    meta: {
      title: 'Coupon',
      icon: ['fas', 'th-list'],
    },
    children: [
      {
        path: 'create',
        component: CouponDetail,
        name: 'CouponCreate',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'coupon',
        },
      },
      {
        path: 'edit/:id',
        component: CouponDetail,
        props: true,
        name: 'CouponEdit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'coupon',
        },
      },
      {
        path: 'list',
        component: CouponList,
        name: 'CouponList',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'coupon',
        },
      },
    ],
  },
]
